import { render, staticRenderFns } from "./VerifyGoogle.vue?vue&type=template&id=5045c53c&scoped=true"
import script from "./VerifyGoogle.vue?vue&type=script&lang=js"
export * from "./VerifyGoogle.vue?vue&type=script&lang=js"
import style0 from "./VerifyGoogle.vue?vue&type=style&index=0&id=5045c53c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5045c53c",
  null
  
)

export default component.exports